// Dashboard V4 Stats API Action Types

// States (Quote Funnels)
export const GET_QF_DASHBOARD_STATS_V4_STATES = "GET_QF_DASHBOARD_STATS_V4_STATES";
export const GET_QF_DASHBOARD_STATS_V4_STATES_SUCCESS = "GET_QF_DASHBOARD_STATS_V4_STATES_SUCCESS";
export const GET_QF_DASHBOARD_STATS_V4_STATES_ERROR = "GET_QF_DASHBOARD_STATS_V4_STATES_ERROR";

// Sources (Quote Funnels)
export const GET_QF_DASHBOARD_STATS_V4_SOURCES = "GET_QF_DASHBOARD_STATS_V4_SOURCES";
export const GET_QF_DASHBOARD_STATS_V4_SOURCES_SUCCESS = "GET_QF_DASHBOARD_STATS_V4_SOURCES_SUCCESS";
export const GET_QF_DASHBOARD_STATS_V4_SOURCES_ERROR = "GET_QF_DASHBOARD_STATS_V4_SOURCES_ERROR";

// Creatives (Quote Funnels)
export const GET_QF_DASHBOARD_STATS_V4_CREATIVES = "GET_QF_DASHBOARD_STATS_V4_CREATIVES";
export const GET_QF_DASHBOARD_STATS_V4_CREATIVES_SUCCESS = "GET_QF_DASHBOARD_STATS_V4_CREATIVES_SUCCESS";
export const GET_QF_DASHBOARD_STATS_V4_CREATIVES_ERROR = "GET_QF_DASHBOARD_STATS_V4_CREATIVES_ERROR";

// Insurance Types (Quote Funnels)
export const GET_QF_DASHBOARD_STATS_V4_INSURANCE_TYPES = "GET_QF_DASHBOARD_STATS_V4_INSURANCE_TYPES";
export const GET_QF_DASHBOARD_STATS_V4_INSURANCE_TYPES_SUCCESS = "GET_QF_DASHBOARD_STATS_V4_INSURANCE_TYPES_SUCCESS";
export const GET_QF_DASHBOARD_STATS_V4_INSURANCE_TYPES_ERROR = "GET_QF_DASHBOARD_STATS_V4_INSURANCE_TYPES_ERROR";

// Overview (Quote Funnels): total_stats + graph_stats
export const GET_QF_DASHBOARD_STATS_V4_OVERVIEW = "GET_QF_DASHBOARD_STATS_V4_OVERVIEW";
export const GET_QF_DASHBOARD_STATS_V4_OVERVIEW_SUCCESS = "GET_QF_DASHBOARD_STATS_V4_OVERVIEW_SUCCESS";
export const GET_QF_DASHBOARD_STATS_V4_OVERVIEW_ERROR = "GET_QF_DASHBOARD_STATS_V4_OVERVIEW_ERROR";
